import React from 'react';
import { Camera, Image as ImageIcon, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface PhotoUploadProps {
  photos: string[];
  onPhotosChange: (photos: string[]) => void;
  maxPhotos?: number;
  label?: string;
}
export function PhotoUpload({
  photos,
  onPhotosChange,
  maxPhotos = 5,
  label
}: PhotoUploadProps) {
  const handleAddPhoto = () => {
    // Simulate photo capture - in real app would use camera/gallery
    const mockPhoto = `https://images.unsplash.com/photo-${Date.now()}?w=400&q=80`;
    if (photos.length < maxPhotos) {
      onPhotosChange([...photos, mockPhoto]);
    }
  };
  const handleRemovePhoto = (index: number) => {
    onPhotosChange(photos.filter((_, i) => i !== index));
  };
  return <div data-id="element-421">
      {label && <label className="block text-sm font-medium text-charcoal mb-3" data-id="element-422">
          {label}
        </label>}

      <div className="grid grid-cols-3 gap-3" data-id="element-423">
        <AnimatePresence data-id="element-424">
          {photos.map((photo, index) => <motion.div key={photo} initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} className="relative aspect-square rounded-ios overflow-hidden bg-sand" data-id="element-425">
              <img src={photo} alt={`Upload ${index + 1}`} className="w-full h-full object-cover" data-id="element-426" />
              <button onClick={() => handleRemovePhoto(index)} className="absolute top-2 right-2 p-1 bg-charcoal/80 rounded-full" data-id="element-427">
                <X size={16} className="text-white" data-id="element-428" />
              </button>
            </motion.div>)}
        </AnimatePresence>

        {photos.length < maxPhotos && <motion.button onClick={handleAddPhoto} whileTap={{
        scale: 0.95
      }} className="aspect-square rounded-ios bg-sand border-2 border-dashed border-moss-gray flex flex-col items-center justify-center gap-2 text-moss-gray hover:border-dark-green hover:text-dark-green transition-colors" data-id="element-429">
            <Camera size={24} data-id="element-430" />
            <span className="text-xs font-medium" data-id="element-431">Add Photo</span>
          </motion.button>}
      </div>

      <p className="text-xs text-moss-gray mt-2" data-id="element-432">
        {photos.length} / {maxPhotos} photos
      </p>
    </div>;
}